/* @jsx h */
import { defineComponent, h } from "vue";
import { AttentionItems, type AttentionItem } from "@app/vue/components/Dashboard/AttentionItems";
import { useLocalization } from "@lemmonhq/uikit";
import type { Dashboard } from "./types";

type Item = AttentionItem;

const COUNT_STALE_DAYS = 14;

/** What needs doing, most urgent first. Exported for tests. */
export function attentionItems(d: Dashboard, t: (k: string) => string, now = Date.now()): Item[] {
  const items: Item[] = [];
  const n = (k: string, count: number) => t(k).replace("{count}", String(count));
  if (d.invoices.overdue_count > 0) {
    items.push({
      icon: "warning", tone: "error", to: "/app/inventory/invoices",
      text: n("inventory.overview.todo_overdue", d.invoices.overdue_count).replace("{amount}", d.invoices.overdue_total.toFixed(2)),
      action: t("inventory.overview.action_pay"),
    });
  }
  if (d.orders.late > 0) {
    items.push({ icon: "schedule", tone: "error", to: "/app/inventory/orders", text: n("inventory.overview.todo_late", d.orders.late), action: t("inventory.overview.action_view") });
  }
  if (d.orders.due_today > 0) {
    items.push({ icon: "local_shipping", tone: "info", to: "/app/inventory/orders", text: n("inventory.overview.todo_due_today", d.orders.due_today), action: t("inventory.overview.action_receive") });
  }
  if (d.todo.draft_deliveries > 0) {
    items.push({ icon: "inventory", tone: "warning", to: "/app/inventory/deliveries", text: n("inventory.overview.todo_drafts", d.todo.draft_deliveries), action: t("inventory.overview.action_post") });
  }
  if (d.stock.below_par_count > 0) {
    items.push({ icon: "production_quantity_limits", tone: "warning", to: "/app/inventory/stock", text: n("inventory.overview.todo_below_par", d.stock.below_par_count), action: t("inventory.overview.action_order") });
  }
  if (d.price_rises.length > 0) {
    items.push({ icon: "trending_up", tone: "warning", to: "/app/inventory/suppliers", text: n("inventory.overview.todo_price_rises", d.price_rises.length), action: t("inventory.overview.action_view") });
  }
  const days = d.todo.last_count_at ? Math.floor((now - new Date(d.todo.last_count_at).getTime()) / 86_400_000) : null;
  if (d.stock.items > 0 && (days == null || days >= COUNT_STALE_DAYS)) {
    items.push({
      icon: "checklist", tone: "info", to: "/app/inventory/counts",
      text: days == null ? t("inventory.overview.todo_first_count") : n("inventory.overview.todo_count", days),
      action: t("inventory.overview.action_count"),
    });
  }
  return items;
}

export const AttentionList = defineComponent<{ dashboard: Dashboard }>({
  name: "AttentionList",
  props: ["dashboard"],
  setup(props) {
    const { t } = useLocalization();
    return () => (
      <AttentionItems items={attentionItems(props.dashboard, t)} emptyText={t("inventory.overview.all_clear")} />
    );
  },
});
